import { Component, OnInit } from '@angular/core';
import { StoreService } from 'src/app/store.service';
import {
  NgbModal,
  ModalDismissReasons,
  NgbCheckBox,
} from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavigationExtras, ActivatedRoute, Router } from '@angular/router';
import { UtilitiesService } from 'src/app/core/utilities.service';

declare const $: any;
type ListingViewMode = 'tile' | 'list';
@Component({
  selector: 'app-product-faq-edit',
  templateUrl: './product-faq-edit.component.html',
  styleUrls: ['./product-faq-edit.component.scss']
})
export class ProductFaqEditComponent implements OnInit {
  bearer;
  store_id;
  checkout_list = [];
  country;
  selectedCountry;
  language_name;
  isChecks = false;
  selectedProducts :string = "";
  mixture_data = [];
  body = {};
  urlData;
  expressUrl;
  buttonFreeze = false;
  checkout_link_id;

  filteredString: string = '';
  filteredCountry: string = '';
  activatedCountry: any[] = [];

  currentLanguage: any = [];
  languageList: any[] = [];
  filteredStatus: string = '';
  filteredStatusDisplay: string = '';
  displayedProducts = [];
  products = [];
  language_code;
  languageSelected;
  updateLink = false;
  countryFirstInit: boolean = false;
  countryLoaded: boolean = false;

  expressCheckoutData: any = [];
  expressCheckoutDataByLanguage = {};

  product_faq_title;
  product_faq_desc;
  productDesc;
  productFaqData;
  productFaqId;

  updatingDisplayQueue = [];
  listingView: ListingViewMode = 'list';

  // Media Editor variables for text editor
  editorMediaPhotoId;
  editorImgURL;

  public initialArrangement = []; // Initially loaded or unchanged arrangement
  public productArrangement = []; // Arrangement state for current listing
  public customArrangement = {}; // Arrangement from backend, multi country
  customArrangementReady = false;
  isSavingArrangement = false;

  loading = true;
  closeResult = '';
  success = 'success';
  generateForm: FormGroup;

  productFilter: string = '';
  filteredSubscription: string = '';
  toggleState: boolean = false;
  quantityConfig = 0;

  checkoutProducts;
  country_code;

  buildForm() {
    const formSchema = {
      product_faq_title: ['']
    };

    this.generateForm = this.formBuilder.group(formSchema);
  }

  constructor(
    private svc: StoreService,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private router: Router,
    private activeRoute: ActivatedRoute,
    public utils: UtilitiesService
  ) {}

  ngOnInit(): void {
    this.bearer = localStorage.getItem('bearer');
    this.store_id = localStorage.getItem('store_id');

    const productFaqId = this.activeRoute.snapshot.params.id;

    this.productFaqId = productFaqId;

    this.buildForm();
    this.getProductFaqInfo(productFaqId);
    this.fetchCountry();
    this.fetchProductList()
      .then(() => {
        const countryCode = this.country_code;

        // // Update country
        this.changeCountry(countryCode);
        this.countryFirstInit = true;

        // update language
        const setLanguage = this.languageList.find((lang) => lang.language_code === this.languageSelected) ?? this.languageList[0];

        this.language_code = setLanguage['language_code'];
        this.language_name = setLanguage['language_name'];

        this.changeLanguage(setLanguage);

        // // Check selected product
        this.insertSelectedProduct(this.checkoutProducts);

        this.updateLink = true;
      })
      .catch((error) => {
        console.log('Loading product error:', { error });
      });
  }

  async fetchProductList() {
    this.loading = true;

    return new Promise((resolve, reject) => {
      this.svc.getStoreLanguage(this.bearer, this.store_id).subscribe(
        (res) => {
          const allLanguages = res['data'];

          const enabledLanguages = allLanguages.filter((lang) => +lang.status);
          const defaultLanguage =
            allLanguages.find((lang) => lang.language_code === this.languageSelected) ?? allLanguages[0];

          this.languageList = enabledLanguages;

          this.language_code = defaultLanguage['language_code'];
          this.language_name = defaultLanguage['language_name'];

          this.changeLanguage(defaultLanguage);

          this.reloadProductList().finally(() => {
            this.generateArrangementList();
            this.loading = false;

            setTimeout(() => {
              resolve(true);
            }, 1);
          });
        },
        (error) => {
          this.loading = false;
          reject(error);
        }
      );
    });
  }

  async reloadProductList() {
    return new Promise((resolve, reject) => {
      this.svc
        .getProductLists(this.bearer, this.store_id, this.language_code)
        .subscribe(
          (res) => {
            let productList = res['data'];
            this.products = productList.filter((product) => +product.display_status === 1);
            this.updateFilter();
            this.generateArrangementList(true);
            resolve(true);
            this.loading = false;
          },
          (error) => {
            this.loading = false;
            reject(error);
          }
        );
    });
  }

  async fetchExpressCheckoutBySlug(slug, countryCode) {
    return new Promise((resolve, reject) => {
      this.svc
        .fetchExpressCheckoutBySlug(
          this.bearer,
          this.store_id,
          slug,
          countryCode
        )
        .subscribe(
          (res) => {
            this.loading = false;
            resolve(res);
          },
          (error) => {
            this.loading = false;
            reject(error);
          }
        );
    });
  }

  saveLastArrangementListChanged(arrangementList = []) {
    this.initialArrangement = arrangementList;
    let countryCode = this.getSelectedCountryCode;
    this.customArrangement[countryCode] = arrangementList;
  }

  saveProductArrangement(event) {
    this.isSavingArrangement = true;
    const body = {
      store_id: this.store_id,
      arrangement: this.productArrangement,
      country_code: this.getSelectedCountryCode,
    };

    this.svc.updateCustomArrangement(body, this.bearer).subscribe(
      (res) => {
        this.isSavingArrangement = false;
        this.saveLastArrangementListChanged(this.productArrangement);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  fetchProductArrangement() {
    this.svc.getProductCustomArrangement(this.bearer).subscribe(
      (res) => {
        this.customArrangement = res?.['data'];
        this.sortByArrangementList();
        this.customArrangementReady = true;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  generateArrangementList(doSort = false) {
    let productArrangement = Object.entries(this.displayedProducts).map(
      (product: any) => +product[1].p_id
    );
    this.productArrangement = productArrangement;
    if (doSort) this.sortByArrangementList();
  }

  sortByArrangementList() {
    this.customArrangement;
    this.productArrangement;

    if (this.customArrangementReady && this.productArrangement?.length) {
      // Arrangement ready
      let countryCode = this.getSelectedCountryCode;
      let newArrangement = [...(this.customArrangement[countryCode] ?? [])];
      this.productArrangement.forEach((p_id) => {
        if (!newArrangement.includes(p_id)) {
          newArrangement.push(p_id);
        }
      });

      this.productArrangement = newArrangement;

      let arrangedProducts = [];
      newArrangement.forEach((p_id) => {
        let productFound = this.displayedProducts.find(
          (product) => +product.p_id === +p_id
        );

        // Only insert non-empty
        if (productFound) arrangedProducts.push(productFound);
      });

      // Replace displayedProducts with arrangedProducts
      this.displayedProducts = arrangedProducts;

      // Save/Reset unchanged arrangement list with new value
      this.saveLastArrangementListChanged(newArrangement);
    }
  }

  get getSelectedCountryCode(): string {
    return this.filteredCountry?.toUpperCase();
  }

  getCountryName(country_code: string) {
    country_code = (country_code || '').toLowerCase();
    const country = this.country?.find(
      (c) => (c.country_code || '').toLowerCase() === country_code
    );
    this.selectedCountry = country_code;
    return country?.country_name ?? country_code;
  }

  fetchCountry() {
    this.svc.getCountry(this.bearer).subscribe((res) => {
      res['data'].forEach((item) => {
        if (item['country_name'] == 'Malaysia-Brunei') {
          item['country_name'] = 'Brunei';
        }
      });
      let defaultCountry = res['data'].find((index) => {
        if (parseInt(index['default']) === 1) {
          return index;
        }
      });

      this.country = [{ country_code: '', country_name: '' }];
      this.filteredCountry = defaultCountry['country_code'];
      this.activatedCountry = [];
      this.countryLoaded = true;
      if (res['data']) {
        res['data'].forEach((value) => {
          value.country_name = value.country_name.split('-').pop().trim();
          this.country.push(value);
          if (+value.status === 1) {
            this.activatedCountry.push(value);
          }
        });
      }
    });
  }

  isUpdatingDisplay(productId) {
    return !!this.updatingDisplayQueue.includes(productId);
  }

  addUpdateDisplayQueue(productId) {
    this.updatingDisplayQueue.push(productId);
  }

  removeUpdateDisplayQueue(productId) {
    this.updatingDisplayQueue = this.updatingDisplayQueue.filter(
      (p) => +p !== +productId
    );
  }

  updateDisplayStatus(productId, displayStatus, event) {
    let body = {
      store_id: this.store_id,
      product_id: productId,
      display: +!displayStatus,
      language_code: this.language_code,
    };

    if (this.isUpdatingDisplay(productId)) return;
    this.addUpdateDisplayQueue(productId);

    this.svc.updateDisplayStatus(body, this.bearer).subscribe(
      (res) => {
        let productData = this.getProductData(productId);
        productData.display_status = res['data']?.display ? '9' : '1';
        this.removeUpdateDisplayQueue(productId);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  updateFilter(event = null) {
    const filteredProducts = this.filterProducts(this.products, [
      this.filteredString,
      this.filteredCountry,
      this.filteredStatus
    ]);
    this.displayedProducts = filteredProducts;
  }

  productFilterChanged(e) {
    this.productFilter = e.target.value;
    this.updateFilter();
  }

  getDisplayedProducts() {
    return this.displayedProducts.filter((product) => {

      const keywords = this.productFilter.toLowerCase().split(' ');
      return keywords.every(
        (keyword) =>
        (product.search_key?.toLowerCase().includes(keyword) && +product.display_status === 1) ||
        (product.product_display_name?.toLowerCase().includes(keyword) && +product.display_status === 1)
      );
    });
  }

  filterProducts(products: any, filterString: any) {
    if (!products || products.length === 0) {
      return products;
    }

    return products.filter((product: any) => {
      // Filter by search query
      const keywordsFilter = filterString[0].toLowerCase().split(' ');
      const keywordsFilterResult = keywordsFilter.every(
        (keyword) => product.product_name.toLowerCase().indexOf(keyword) >= 0
      );

      // Filter by country
      const countryFilter = filterString[1];
      const countryFilterResult =
        countryFilter === '' || product['country_code'] === countryFilter;

      // Filter by status
      const statusFilter = filterString[2];
      const statusFilterResult =
        statusFilter === '' || product['display_status'] === statusFilter;


      return (
        keywordsFilterResult &&
        countryFilterResult &&
        statusFilterResult
      );
    });
  }

  changeCountry(countryCode) {
    this.filteredCountry = countryCode;
    this.selectedProducts = '';
    this.updateFilter();
    this.generateArrangementList(true);
  }

  changeLanguage(languageData) {
    const { languageList } = this;

    if (languageData !== undefined) {
      let foundLanguage = languageList.find((language) => {
        return (
          language?.language_code?.toLowerCase() ===
          languageData?.language_code?.toLowerCase()
        );
      });

      languageData = foundLanguage;
      this.currentLanguage = languageData;
      this.updateLink = true;
      this.toggleState = false;
      this.quantityConfig = 0;

    }
  }

  getLanguageName(languageData) {
    return languageData.language_name;
  }

  open(content, id) {
    this.modalService
      .open(content, {
        ariaLabelledBy: 'modal-basic-title',
        centered: true,
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
          if (result == 'delete') {
            // this.deleteLink(id);
          }
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  get isTileView() {
    return true;
    return this.listingView === 'tile';
  }
  get isListView() {
    return this.listingView === 'list';
  }

  getProductData(productId: number) {
    return this.displayedProducts.find(
      (product) => +product.p_id === +productId
    );
  }

  getEditProductLink(productId: number) {
    const { language_code } = this;
    return `/dashboard/product/edit/${productId}/${language_code}`;
  }

  getFlagByCountryCode(country_code: string) {
    country_code = (country_code || '').toLowerCase().substr(-2, 2);
    country_code = country_code === 'cm' ? 'kh' : country_code;
    return country_code;
  }

  getFlagImageURL(country_code: string) {
    country_code = this.getFlagByCountryCode(country_code);
    return `https://cdn.estore5s.com/asset/flags/${country_code}.png`;
  }

  productClick(pid) {
    this.insertSelectedProduct(pid);
  }

  insertSelectedProduct(pid) {

    let productFind = this.products.find((product) => +product.p_id === +pid);

    if(typeof productFind !== 'undefined') {
        this.selectedProducts = pid;
        this.body['product_id'] = this.selectedProducts;
    }

  }

  isProductSelected(pid) {
    return this.selectedProducts === pid;
  }

  getErrorMessage(error = null, message = null) {
    if (error?.error?.messages?.error) {
      this.utils.notify.showError(error?.error?.messages?.error);
    } else if (error?.error?.data) {
      let err = Object.values(error?.error?.data);
      let msg = message + '\n\n';
      let i = 0;
      err.forEach((value) => {
        msg += this.utils.translate(value);
        i++;
        if (i < err.length) {
          msg += '\n';
        }
      });
      this.utils.notify.showError(msg);
    } else {
      this.utils.notify.showError(message ?? this.utils.translate('Update failed!'));
    }
    this.utils.msgBox.open({
      message: this.utils.translate(message ?? this.utils.translate('Update failed!')),
      title: this.utils.translate('Error'),
      icon: 'error',
      contentClassList: 'whitespace-pre-line',
    });
  }

  filterNonUrlCharacters(event) {
    let url = this.generateForm.get('url').value;
    let sanatizedUrl = url
      .trim()
      .replace(/[^a-zA-Z0-9-]/g, '')
      .replace(/--/g, '-');
    if (sanatizedUrl[0] === '-') sanatizedUrl = sanatizedUrl.substr(1);
    this.generateForm.get('url').setValue(sanatizedUrl);
  }

  /*
  Image Upload for Trumbowyg content editor
  */
  lastInsertImageCallback: Function;
  handleTrumbowygMediaChanged(event) {
    console.log('handleTrumbowygMediaChanged', { event });
    this.lastInsertImageCallback(event.url);
  }

  handleSetInsertImageCallback(event) {
    console.log('handleSetInsertImageCallback', { event });
    this.lastInsertImageCallback = event.detail.InsertImageCallback;
  }

  initContentEditor() {
    let defaultButtons = $.trumbowyg.defaultOptions.btns;

    defaultButtons[3] = [
      'fontsize',
      'foreColor',
      'backColor',
    ];

    setTimeout(() => {
      $.trumbowyg.svgPath = '/library/trumbowyg-dist/ui/icons.svg';
      setTimeout(() => {
        $('.text-textarea').trumbowyg();
      }, 10);

      $(
        '#product_faq_desc.content-editor-textarea'
      ).trumbowyg({
        btns: defaultButtons,
      });
    }, 1000);
  }

  updateFaq() {
    if (this.selectedProducts === '') {
      this.utils.msgBox.open({
        title: this.utils.translate('Uh oh!'),
        icon: 'warning',
        message: this.utils.translate('Please select at least 1 product.'),
      });
      return;
    }

    let languageCode = this.currentLanguage['language_code'];

    let productSelected = this.displayedProducts.find((product) => {
      return +product.p_id === +this.selectedProducts
    })

    this.product_faq_title = this.generateForm.get('product_faq_title').value;
    this.product_faq_desc = $(`#product_faq_desc.content-editor-textarea`)[0].value;

    this.body['id'] = this.productFaqId;
    this.body['store_id'] = this.store_id;
    this.body['country_code'] = this.selectedCountry.toUpperCase();
    this.body['title'] = this.product_faq_title;
    this.body['description'] = this.product_faq_desc;
    this.body['language_code'] = languageCode;

    this.buttonFreeze = true;
    this.postUpdateFaq();
  }

  postUpdateFaq() {

    this.svc.postUpdateFaq(this.body, this.bearer).subscribe(
      (res) => {
        this.loading = true;
        this.utils.notify.showSuccess(this.utils.translate('FAQs Successfully Updated'));
        setTimeout(() => {
          this.router.navigate(['/dashboard/product-faq']);
        }, 2000);
      },
      (error) => {
        this.loading = false;
        this.utils.notify.showError(this.utils.translate('Failed to Update FAQs'));
        this.getErrorMessage(error, this.utils.translate('Failed to Update FAQs'));
        this.buttonFreeze = false;
      }
    );
  }

  getProductFaqInfo(faqid: number) {
    this.loading = true;
    this.productFaqData = {};

    this.svc
      .getProductFaqById(this.bearer, faqid)
      .subscribe((res) => {

        this.checkoutProducts = res['data']['product_id'];
        this.country_code = res['data']['country_code'];
        this.languageSelected = res['data']['language_code'];
        this.productDesc = res['data']['description'];

        this.generateForm
        .get('product_faq_title')
        .setValue(res['data']['title'] ?? '');

        this.initContentEditor();

      });
  }
}
